import BaseModelAPI from '../BaseModelAPI';

export default class ProblemCategory extends BaseModelAPI {
	static entity = 'problemcategory';
	static entityName = 'problemcategory';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}